import RelativeDatepicker from './relative-datepicker';
import './relative-datepicker.scss';

export default RelativeDatepicker;
